import { BodyContainer } from "App/styles";
import { MainTitle } from "components/MainTitle";
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { DescriptionContainer } from "./styles";
import topicsUrl from "../../data/topics.md?url";

export default function ExplanationTopicsAwards() {
  const [text, setText] = useState("");

  useEffect(() => {
    fetch(topicsUrl)
      .then((res) => res.text())
      .then((res) => setText(res))
      .catch((err) => console.log(err));
  });

  return (
    <BodyContainer>
      <MainTitle title="Temáticas" seoTitle="Temáticas" />
      <DescriptionContainer>
        <ReactMarkdown>{text}</ReactMarkdown>
      </DescriptionContainer>
    </BodyContainer>
  );
}
